export const siteSettings = {
  name: "Global Finex Pro",
  link: "https://globalfinexpro.net",
  email: "support@globalfinexpro.net",
  appLink: "https://app.globalfinexpro.net",
};
